<template>
  <div class="main">
    <div class="container" :style="{'margin-left': offsetData+'px'}">
      <div
        v-for="i,index in imglist"
        :key="index"
        @mouseenter="clearScroll()"
        @mouseleave="startScroll()"
        class="imgbox">
        <v-img
          contain
          height="100"
          @click="sel(i)"
          :src="i.thumbnail">
        </v-img>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  data(){
    return{
      offsetData:0,
      direction:'left',
      speed:10,
    }
  },
  props:{
    imglist:{
      type:Array,
    }
  },
  methods:{
    sel(v){
      this.$emit('sel',v);
    },
    ScrollPic (data, direction, speed) {
      if (direction === 'left') {
        this.scrollInterval = setInterval(() => {
          this.offsetData--;
          this.ScrollDataSet(direction, data);
        }, speed);
      } else {
        this.scrollInterval = setInterval(() => {
          this.offsetData++;
          this.ScrollDataSet(direction, data);
        }, speed);
      }
    },
    ScrollDataSet (direction, data) {
      let $d = document.getElementsByClassName('imgbox');
      let wd = $d[ 0 ].clientWidth;
      // 当一个元素跑出可视区域，删除这个元素，并添加在最后面
      if (direction === 'left') {
        if (Math.abs(this.offsetData) === 1)
          data.push(data[ 0 ]);

        if (Math.abs(this.offsetData) >= wd) {
          data.splice(0, 1);
          this.offsetData = 0;
        }
      } else {
        if (Math.abs(this.offsetData) === 1)
          data.unshift(data[ data.length - 1 ]);

        if (Math.abs(this.offsetData) >= wd) {
          data.splice(-1, 1);
          this.offsetData = 0;
        }
      }
    },
    startScroll () {
      this.ScrollPic(this.imglist,this.direction,this.speed);
    },
    clearScroll () {
      clearInterval(this.scrollInterval);
    },
  },
  mounted(){
    this.startScroll(this.imglist,this.direction,this.speed);
  },
  beforeDestroy(){
    this.clearScroll();
  },
  watch:{
    imglist(){
      this.clearScroll();
      this.startScroll();
    }
  }
}
</script>

<style scoped>
.main{
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.container{
  display:flex;
}
.imgbox{
  width: 200px;
  height: 100px;
  display: flex;
  align-items:center;
  padding:0 4px;
  border: 0.5px solid  #dedede;
}
</style>
